import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createWorkspacePlan } from "api/services/workspace-plan-service";
import { ISaveWorkspacePlanRequest } from "api/models/request/workspacePlan/ISaveWorkspacePlanRequest";
import { IWorkspacePlanModel } from "api/models/response/workspacePlan/IWorkspacePlanModel";
import { WORKSPACE_PLANS_QUERY_KEY } from "hooks/workspacePlan/queryKeys";

export const useCreateWorkspacePlan = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (request: ISaveWorkspacePlanRequest): Promise<IWorkspacePlanModel> => {
            const response = await createWorkspacePlan(request);
            if (!response.success || !response.data) {
                throw new Error(response.message ?? "subscriptionPlan.createError");
            }

            return response.data;
        },
        onSuccess: (createdPlan) => {
            queryClient.setQueryData<IWorkspacePlanModel[]>(WORKSPACE_PLANS_QUERY_KEY, (prev) =>
                prev ? [...prev, createdPlan] : [createdPlan]
            );
            queryClient.invalidateQueries({ queryKey: WORKSPACE_PLANS_QUERY_KEY });
        },
    });

    return {
        createPlan: mutation.mutateAsync,
        creatingPlan: mutation.isPending,
    };
};
